import { render } from "./HeroiconsSolidMap.vue?vue&type=template&id=1af3da7c"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMap.vue"]])

export default __exports__